import React from 'react';

const FormCheckbox = ({
    divClass,
    inputClass,
    labelClass,
    spanClass,
    label,
    hook,
    name,
    value,
    type,
    onChange,
    checked
}) => {
    return (
        <div className={divClass}>
            <label className={labelClass} htmlFor={hook}>
                <input
                    className={inputClass}
                    type={type}
                    id={hook}
                    name={name}
                    value={value}
                    onChange={onChange}
                    checked={checked}
                />

                {label}
            </label>
        </div>
    );
};

export default FormCheckbox;
